<template>
  <div class="tit-wrap">
    <h1 class="app-tit">{{ t('question_withdraw_reason') }}</h1>
    <p>{{ t('provide_better_service') }}</p>
  </div>

  <div class="radio-wrap">
    <label class="app-radio-primary" v-for="(option, index) in withdrawReasonOptions" :key="index">
      <input type="radio" name="sel-radio" :value="option.value" v-model="selectedOption" />
      <span>{{ option.label }}</span>
    </label>

    <div class="textarea-wrap">
      <textarea v-model="withdrawReason" maxlength="200" @click="handleClick" />
      <span>{{ withdrawReason.length }} / 200</span>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();

const selectedOption = ref<string>('');
const withdrawReason = ref<string>('');

const isCustomReason = computed<boolean>(() => {
  return selectedOption.value === t('ss_survey_answer_compose', {}, { locale: 'ko' });
});

const withdrawReasonOptions = computed(() => {
  return [
    {
      label: t('survey_delete_account_plan'),
      value: t('survey_delete_account_plan', {}, { locale: 'ko' }),
    },
    {
      label: t('ss_survey_delete_account_security'),
      value: t('ss_survey_delete_account_security', {}, { locale: 'ko' }),
    },
    {
      label: t('ss_survey_delete_account_history'),
      value: t('ss_survey_delete_account_history', {}, { locale: 'ko' }),
    },
    {
      label: t('ss_survey_unsubscribe_answer_account'),
      value: t('ss_survey_unsubscribe_answer_account', {}, { locale: 'ko' }),
    },
    {
      label: t('ss_survey_answer_compose'),
      value: t('ss_survey_answer_compose', {}, { locale: 'ko' }),
    },
  ];
});

const handleClick = () => {
  if (!isCustomReason.value) {
    selectedOption.value = t('ss_survey_answer_compose', {}, { locale: 'ko' });
  }
};

defineExpose({ selectedOption, withdrawReason, isCustomReason });
</script>

<style scoped lang="scss">
.tit-wrap {
  margin-bottom: 2.5rem;
  .app-tit {
    margin-bottom: 0.5rem;
  }
  p {
    font-size: $font-size-psmall;
    color: $color-gray-200;
  }
}
.radio-wrap {
  label {
    &:not(:first-child) {
      margin-top: $size-l;
    }
  }
  .textarea-wrap {
    margin-top: $size-s;
    textarea {
      font-size: $font-size-psmall;
      min-height: 5rem;
      &:focus {
        border: 1px solid $color-gray-900;
        box-shadow: none;
      }
    }
    span {
      display: block;
      width: 100%;
      margin-top: $size-xs;
      text-align: right;
      font-size: $font-size-xs;
      color: $color-gray-200;
    }
  }
}
</style>
